/** Equirectangular local frame in metres around a mission (spec §4.1 step 1). */
import type { LngLat, XY } from './types';

const METRES_PER_DEGREE = 40075017 / 360;

export interface Frame {
  lng0: number;
  lat0: number;
  mPerDegLng: number;
  mPerDegLat: number;
}

export function frameAround(points: LngLat[]): Frame {
  const n = Math.max(1, points.length);
  const lng0 = points.reduce((s, p) => s + p[0], 0) / n;
  const lat0 = points.reduce((s, p) => s + p[1], 0) / n;
  return { lng0, lat0, mPerDegLng: METRES_PER_DEGREE * Math.cos((lat0 * Math.PI) / 180), mPerDegLat: METRES_PER_DEGREE };
}

export function toLocal(f: Frame, p: LngLat): XY {
  return { x: (p[0] - f.lng0) * f.mPerDegLng, y: (p[1] - f.lat0) * f.mPerDegLat };
}

export function toWgs(f: Frame, p: XY): LngLat {
  return [f.lng0 + p.x / f.mPerDegLng, f.lat0 + p.y / f.mPerDegLat];
}

/** Rotate about the origin, counter-clockwise by `deg`. */
export function rotate(p: XY, deg: number): XY {
  const r = (deg * Math.PI) / 180;
  const c = Math.cos(r);
  const s = Math.sin(r);
  return { x: p.x * c - p.y * s, y: p.x * s + p.y * c };
}

export function dist(a: XY, b: XY): number {
  return Math.hypot(a.x - b.x, a.y - b.y);
}
